import { useState, type FormEvent } from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../auth'

export function Login() {
  const { me, signIn, confirmMfa, pendingMfa, error } = useAuth()
  const navigate = useNavigate()
  const location = useLocation() as { state?: { from?: string } }
  const [email, setEmail] = useState('demo@auditai.co.th')
  const [password, setPassword] = useState('DemoAudit2026!')
  const [busy, setBusy] = useState(false)
  const [code, setCode] = useState('')

  if (me) return <Navigate to={location.state?.from ?? '/'} replace />

  async function submit(e: FormEvent) {
    e.preventDefault()
    setBusy(true)
    try {
      const result = await signIn(email, password)
      if (result === 'ok') navigate(location.state?.from ?? '/', { replace: true })
    } catch {
      /* error surfaced by provider */
    } finally {
      setBusy(false)
    }
  }

  async function submitCode(e: FormEvent) {
    e.preventDefault()
    setBusy(true)
    try {
      await confirmMfa(code)
      navigate(location.state?.from ?? '/', { replace: true })
    } catch {
      /* error surfaced by provider */
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="login">
      <section className="login-art">
        <div className="brand">
          <span className="brand-mark" />
          <span className="brand-word">AUDIT<span>AI</span></span>
        </div>
        <div className="login-quote rise">
          <div className="eyebrow" style={{ color: 'var(--color-gold)' }}>หลักฐานนำ · คำอธิบายตาม</div>
          <h2>ความจริงทางการเงิน<br />ไม่ควรรอการตรวจสอบด้วยมือ</h2>
          <p>
            แพลตฟอร์มตรวจสอบบัญชีที่แปลงเอกสารเป็นหลักฐาน ตรวจด้วยกฎที่อธิบายได้
            และปิดทุกข้อสังเกตด้วยการอนุมัติของมนุษย์ — ทุกก้าวมีร่องรอยที่ตรวจสอบย้อนกลับได้
          </p>
        </div>
        <div className="login-foot">
          <span>PDPA READY</span>
          <span>HASH-CHAINED AUDIT TRAIL</span>
          <span>THB · ASIA/BANGKOK</span>
        </div>
      </section>

      <section className="login-panel">
        <div className="login-card rise">
          <h1>{pendingMfa ? 'ยืนยันสองขั้นตอน' : 'เข้าสู่ระบบ'}</h1>
          <p className="dim" style={{ marginTop: 8, fontSize: 12.5 }}>
            {pendingMfa ? 'เปิดแอป Authenticator แล้วกรอกรหัส 6 หลัก' : 'สำหรับทีมตรวจสอบภายในและผู้สอบบัญชี'}
          </p>
          {pendingMfa ? (
            <form onSubmit={submitCode}>
              <div className="field">
                <label htmlFor="code">รหัสจากแอป</label>
                <input id="code" className="input mono" inputMode="numeric" pattern="[0-9]{6}" maxLength={6}
                  autoFocus value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))} required
                  style={{ letterSpacing: '0.4em', fontSize: 18 }} />
              </div>
              {error ? <div className="form-error">{error}</div> : null}
              <button className="btn btn-primary" type="submit" disabled={busy || code.length !== 6}
                style={{ width: '100%', height: 42, marginTop: 22, justifyContent: 'center' }}>
                {busy ? 'กำลังตรวจสอบ…' : 'ยืนยัน'}
              </button>
            </form>
          ) : (
          <form onSubmit={submit}>
            <div className="field">
              <label htmlFor="email">อีเมลองค์กร</label>
              <input id="email" className="input" type="email" autoComplete="username" value={email}
                onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <div className="field">
              <label htmlFor="password">รหัสผ่าน</label>
              <input id="password" className="input" type="password" autoComplete="current-password" value={password}
                onChange={(e) => setPassword(e.target.value)} required minLength={12} />
            </div>
            {error ? <div className="form-error">{error}</div> : null}
            <button className="btn btn-primary" type="submit" disabled={busy}
              style={{ width: '100%', height: 42, marginTop: 22, justifyContent: 'center' }}>
              {busy ? 'กำลังตรวจสอบ…' : 'เข้าสู่ระบบ'}
            </button>
          </form>
          )}
          <div className="demo-note">
            บัญชีสาธิต: <span className="mono">demo@auditai.co.th</span> · รหัสผ่าน <span className="mono">DemoAudit2026!</span>
          </div>
        </div>
      </section>
    </div>
  )
}
